import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadingFal: false,
  loadingSawn:false,
  falseFile: [],
  falseSewn:[],
  data:{},
  image:null
};


const newSlice = createSlice({
    name: "print",
    initialState,
    reducers: {
        getFalsePrintFile(state, action){
          state.loadingFal = false;
          state.falseFile = action.payload;
          if(state.falseFile.length!== 0)
          state.loadingFal = true;
      },
      getFalseSewnFile(state, action){
        // console.log(action.payload);
        
        state.loadingSawn = false;
        state.falseSewn = action.payload;
        if(state.falseSewn.length!== 0)
        state.loadingSawn = true;
    },
      loading(state, action) {
        state.loading = action.payload;
      },
    },
  });

  export default newSlice.reducer;
  export const {
    getFalseSewnFile,
    getFalsePrintFile,
    loadingFal,
  } = newSlice.actions;